import {api2Endpoint} from 'app/config/apiConfig'
import {queryClient, queryDefaults} from 'app/react-query'
import {UseQueryResult, useQuery} from 'react-query'
import {getData} from '../api/useGetData'
import {announceReturn, announceSend} from '../api/utils/announce'
import errorNotify from '../api/utils/errorNotify'

export type ApiLogEntry = {
  id: string
  route: string
  method: string
  body: string | null
  request_timestamp: string
  response_timestamp: string | null
  status_code: number | null
  error_message: string | null
  error_class: string | null
  error_trace: string | null
  error_display_message: string | null
  api_version: string
  api_env: string
  user_id: string | null
  tenant_id: string | null
}

export type ApiLogQuery = {
  __page?: number

  id?: string
  route?: string
  method?: string
  body?: string
  request_timestamp?: string
  response_timestamp?: string
  status_code?: number
  error_message?: string
  error_class?: string
  error_trace?: string
  error_display_message?: string
  api_version?: string
  api_env?: string
  user_id?: string
  tenant_id?: string

  id__gt?: string
  route__gt?: string
  method__gt?: string
  body__gt?: string
  request_timestamp__gt?: string
  response_timestamp__gt?: string
  status_code__gt?: number
  error_message__gt?: string
  error_class__gt?: string
  error_trace__gt?: string
  error_display_message__gt?: string
  api_version__gt?: string
  api_env__gt?: string
  user_id__gt?: string
  tenant_id__gt?: string

  id__gte?: string
  route__gte?: string
  method__gte?: string
  body__gte?: string
  request_timestamp__gte?: string
  response_timestamp__gte?: string
  status_code__gte?: number
  error_message__gte?: string
  error_class__gte?: string
  error_trace__gte?: string
  error_display_message__gte?: string
  api_version__gte?: string
  api_env__gte?: string
  user_id__gte?: string
  tenant_id__gte?: string

  id__lt?: string
  route__lt?: string
  method__lt?: string
  body__lt?: string
  request_timestamp__lt?: string
  response_timestamp__lt?: string
  status_code__lt?: number
  error_message__lt?: string
  error_class__lt?: string
  error_trace__lt?: string
  error_display_message__lt?: string
  api_version__lt?: string
  api_env__lt?: string
  user_id__lt?: string
  tenant_id__lt?: string

  id__lte?: string
  route__lte?: string
  method__lte?: string
  body__lte?: string
  request_timestamp__lte?: string
  response_timestamp__lte?: string
  status_code__lte?: number
  error_message__lte?: string
  error_class__lte?: string
  error_trace__lte?: string
  error_display_message__lte?: string
  api_version__lte?: string
  api_env__lte?: string
  user_id__lte?: string
  tenant_id__lte?: string

  id__incl?: string
  route__incl?: string
  method__incl?: string
  body__incl?: string
  request_timestamp__incl?: string
  response_timestamp__incl?: string
  status_code__incl?: number
  error_message__incl?: string
  error_class__incl?: string
  error_trace__incl?: string
  error_display_message__incl?: string
  api_version__incl?: string
  api_env__incl?: string
  user_id__incl?: string
  tenant_id__incl?: string

  id__excl?: string
  route__excl?: string
  method__excl?: string
  body__excl?: string
  request_timestamp__excl?: string
  response_timestamp__excl?: string
  status_code__excl?: number
  error_message__excl?: string
  error_class__excl?: string
  error_trace__excl?: string
  error_display_message__excl?: string
  api_version__excl?: string
  api_env__excl?: string
  user_id__excl?: string
  tenant_id__excl?: string
}

export function useGetApiLog(
  logQuery: ApiLogQuery,
  errMsg = 'Could not retrieve API log.'
): UseQueryResult<ApiLogEntry[], unknown> {
  return useQuery({
    queryKey: [`api_log`, JSON.stringify(logQuery)],
    queryFn: async () => {
      try {
        const method = 'get'
        const route = `admin/api_log`
        announceSend(method, route)
        // // TEST Evan probably needs to review this -- Not seeing a route for this one in fastapi
        //const output = await getData<ApiLogEntry[]>(apiEndpoint(route, logQuery))
        const output = await getData<ApiLogEntry[]>(api2Endpoint(route, logQuery))
        announceReturn(method, route)
        return output
      } catch (err) {
        errorNotify(err, errMsg)
      }
    },
    cacheTime: queryDefaults.cacheTime,
    staleTime: queryDefaults.staleTime,
    retry: queryDefaults.retry,
  })
}

export function refreshApiLog(logQuery: ApiLogQuery) {
  queryClient.invalidateQueries([`api_log`, JSON.stringify(logQuery)])
}
